import React from "react";
import { Box, Flex, Link, Text } from "@chakra-ui/react";
import { TLocationHandler } from "../_types/location.type";
import { FormButton } from "../../../components/login/button.component";
import { AccountRecovery } from "../AccountRecovery/AccountRecovery";

interface IAccountBlockProps {
  locationHandler: TLocationHandler;
  email: string;
}

export const AccountBlockForm = (props: IAccountBlockProps) => {
  const pagePasswordReset = () => {
    props.locationHandler(<AccountRecovery locationHandler={props.locationHandler} />);
  };

  return (
    <Flex fontFamily="Poppins" fontWeight={500} display="flex" alignItems="center" mt="0px" w={396}>
      <Flex direction="column" w="100%">
        <Text fontSize="32px" textAlign="center">
          Conta bloqueada
        </Text>
        <Box alignSelf="center" mt={12}>
          <Text fontSize="12px" textAlign="center">
            Depois de muitas tentativas de login falhas, por medida de segurança a conta associada ao email{" "}
            <strong>{props.email}</strong> foi temporariamente bloqueada.
          </Text>
          <Text fontSize="12px" textAlign="center" mt={6}>
            Clique no botão abaixo para redefinir sua senha e acessar sua conta novamente.
          </Text>
          <Flex direction="column" mt={12}>
            <FormButton
              onClick={() => {
                pagePasswordReset();
              }}
            >
              Recuperar acesso
            </FormButton>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
};
